<template>
    <div class="os-selector-inline">
        <a-select
            mode="multiple"
            v-model="selectedOS"
            style="width: 100%"
            :filter-option="false"
            @search="getOsBySearch"
            @change="() => getOsBySearch()"
            :not-found-content="fetching ? undefined : null"
        >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="item of items" :key="item.key" :value="item.key">
                {{ item.value }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "OSSelectorInline",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        fetching: false,
        selectedOS: [],
        items: [],
        searchTimeout: null,
    }),
    mounted() {
        if (Array.isArray(this.value)) this.selectedOS = this.value;
        this.getOsBySearch();
    },
    methods: {
        ...mapActions({
            getContactByField: "visitor/getContactByField",
        }),
        getOsBySearch(query) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.fetching = true;
                this.getContactByField({ field: "os", query }).then((items) => {
                    this.items = this.$_.uniq(items).map((item) => ({
                        key: item,
                        value: item,
                    }));
                    this.fetching = false;
                });
            }, 500);
        },
        watch: {
            selectedOS() {
                this.$emit("input", this.selectedOS);
            },
            value() {
                this.selectedOS = this.value;
            },
        },
    },
};
</script>
